import React from "react"
import {
  Router, Route,
  Switch
} from "react-router-dom";
import Header from "./commons/header";
import {Provider} from "react-redux";
import store from "../model/store";
import history from "../history";
import NotFound from "./commons/not_found";
import {MainDiv, BodyDiv} from "./style/header_styles"
import ListNamespaces from "./commons/list_namespaces";
import Home from "src/view/commons/home";
import ListExperiments from "src/view/modelTraining/experiments/list_experiments";
import CreateExperiment from "src/view/modelTraining/experiments/create_experiment";
import CreateNamespace from "src/view/modelTraining/namespace/create_namespace";
import UpdateNamespace from "src/view/modelTraining/namespace/update_namespace";
import ListRunways from "src/view/modelTraining/runways/list_runways";
import EditExperiment from "src/view/modelTraining/experiments/edit_experiment";
import NavigationBar from "./commons/navigationPanel/navigation_bar";
import {SnackBar} from "src/view/commons/snack_bar";
import BreadCrumb from "src/view/commons/breadCrumb/breadcrumb_bar";
import ListConfigurations from "./configPanel/list_configurations";
import ViewConfiguration from "src/view/configPanel/view_configuration";
import FeatureGenerationNamespaceDetail from "./featureGeneration/namespace/feature_generation_namespace_detail";
import FeatureGenerationNamespaceForm from "./featureGeneration/namespace/feature_generation_namespace_form";
import FeatureGenerationJobsView from "./featureGeneration/jobs/feature_generation_jobs_view";
import FeatureGenerationJobForm from "./featureGeneration/jobs/feature_generation_job_form";
import EditConfiguration from "src/view/configPanel/edit_configuration";
import DatasetComponent from "src/view/dataset/dataset_component";
import ViewNamespace from "src/view/modelTraining/namespace/view_namespace";
import {ConnectedRouter} from "connected-react-router";
import CreateRunway from "src/view/modelTraining/runways/create_runway";
import UpdateRunway from "src/view/modelTraining/runways/update_runway";
import ViewRunway from "src/view/modelTraining/runways/view_runways";
import ViewRunwayExecutions from "src/view/modelTraining/runways/runway_executions";
import Review from "./review/review";
import Merge from "./review/merge";

export const App = () => {
    //TODO: Change Router Logic With Routes.ts
    return (
      <Provider store={store}>
        <MainDiv style={{ maxWidth: "1500px", margin: "auto" }}>
          <ConnectedRouter history={history}>
            <Switch>
                <Route path={"/"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <Home/>
                    </BodyDiv>
                </Route>
                <Route path={"/configPanel/:teamId/namespaces"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListNamespaces/>
                    </BodyDiv>
                </Route>
                <Route path={"/configPanel/:teamId/namespaces/:namespaceId/configs"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListConfigurations/>
                    </BodyDiv>
                </Route>
                <Route path={"/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/view"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ViewConfiguration/>
                    </BodyDiv>
                </Route>
                <Route path={"/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/merge"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <Merge/>
                    </BodyDiv>
                </Route>
                <Route path={"/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/edit"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <EditConfiguration/>
                    </BodyDiv>
                </Route>
                <Route path={"/featureGeneration/:teamId/namespaces"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListNamespaces/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListNamespaces/>
                    </BodyDiv>
                </Route>
                <Route
                    path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/experiments/create"}
                    exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <CreateExperiment/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/experiments"}
                       exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListExperiments/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/create"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <CreateNamespace/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/view"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ViewNamespace/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/edit"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <UpdateNamespace/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/:experimentName/edit"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <EditExperiment/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ListRunways/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/create"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <CreateRunway/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/:version/update"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <UpdateRunway/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/view"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ViewRunway/>
                    </BodyDiv>
                </Route>
                <Route path={"/modelTraining/:teamId/namespaces/:namespaceId/runways/:runwayId/executions"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <ViewRunwayExecutions/>
                    </BodyDiv>
                </Route>
                <Route path={"/featureGeneration/:teamId/namespaces/:namespaceId/view"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <FeatureGenerationNamespaceDetail/>
                    </BodyDiv>
                </Route>
                <Route path={"/featureGeneration/:teamId/namespaces/new"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <FeatureGenerationNamespaceForm/>
                    </BodyDiv>
                </Route>
                <Route path={"/featureGeneration/:teamId/namespaces/:namespaceId/jobs"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <FeatureGenerationJobsView/>
                    </BodyDiv>
                </Route>
                <Route path={"/featureGeneration/:teamId/namespaces/:namespaceId/jobs/new"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <FeatureGenerationJobForm/>
                    </BodyDiv>
                </Route>
                {/*TODO: Change Dataset Path Later If Needed*/}
                <Route path={"/datasets"} exact>
                    <Header/>
                    <NavigationBar/>
                    <BreadCrumb/>
                    <BodyDiv>
                        <DatasetComponent/>
                    </BodyDiv>
                </Route>
                <Route path={"/review/:reviewId"} exact>
                    <Header/>
                    <BodyDiv style={{top:"50px"}}>
                        <Review/>
                    </BodyDiv>
                </Route>
                <Route path={"/notFound"} exact component={NotFound}/>
                <Route component={NotFound}/>
            </Switch>
          </ConnectedRouter>
            <SnackBar timeOut={3000}/>
        </MainDiv>
      </Provider>
    );
}

export default App;